class ProductMismatchError extends Error {
  constructor(expectedProduct, actualProduct) {
    super(
      `Frontend product mismatch: built for "${expectedProduct}", backend returned "${actualProduct ?? 'empty'}"`,
    )
    this.name = 'ProductMismatchError'
    this.expectedProduct = expectedProduct
    this.actualProduct = actualProduct ?? null
  }
}

function assertProductMatch(expectedProduct, actualProduct) {
  if (actualProduct !== expectedProduct) {
    throw new ProductMismatchError(expectedProduct, actualProduct)
  }
}

export {assertProductMatch, ProductMismatchError}
